import { thousandSeparator } from './thousandSeparator';

export function formatPercentage(value: number): string {
  const valueInPercentage = value * 100.0;
  return `${thousandSeparator(valueInPercentage)} %`;
}
